<template>
  <div class="me-1" id="switch">  
    <notification-button :unread-count="unreadCount" />
    <notification-area />
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'
import NotificationButton from '@/views/atoms/NotificationButton'
import NotificationArea from '@/views/templates/NotificationArea'

export default {
  name: "NotificationHistoryBrowseItem",
  components: {
    NotificationButton,
    NotificationArea,
  },
  mixins: [AddonLoadPageEvent],
  inject: [
    '$constant',
  ],
  data() {
    return {
      timerId: null
    }
  },
  computed: {
    ...mapState('mail_history_index', {
      unreadCount: state => state.unreadCount,
      isNewMail: state => state.isNewMail,
    }),
    ...mapState('mail_history_index', [
      'mailHistories',
    ]),
  },
  mounted() {
    this.loadMailHistorySummary();
    this.timerId = setInterval(() => this.loadMailHistorySummary(), this.$constant.NOTIFICATER.FETCH_INTERVAL_TIME);
  },
  beforeUnmount() {
    clearInterval(this.timerId);
  },
  methods: {
    ...mapMutations('mail_history_index', [
      'setCurrentPage',
      'setCurrentPageCountUp',
    ]),
    loadPage() {
      this.setCurrentPage({ value: 1 });
    },
    loadMailHistorySummary() {
      sessionStorage.setItem('hideApiLoading', 'true');
      this.$store.dispatch('mail_history_index/getMailHistorySummary').then(() => {
        if (this.isNewMail == true) {
          this.setCurrentPage({ value: 1 });
          this.$store.dispatch('mail_history_index/load').then(() => {
            this.setCurrentPageCountUp();
          }).catch(() => this.$root.failApi());
        }
      }).catch(reason => {
        this.$root.failApi(reason);
      }).finally(() => {
        sessionStorage.removeItem('hideApiLoading');
      });
    }
  }
}
</script>